import { useState, type FormEvent } from "react";
import { Link, Navigate } from "react-router-dom";

import { useAuthStore } from "@/auth/authStore";
import { useLanguage } from "@/i18n/LanguageContext";
import { ApiError, submitPaper } from "./api";
import { PageHeader } from "./shells/PageHeader";

export function SubmitPaperPage() {
  const { t, locale } = useLanguage();
  const accessToken = useAuthStore((s) => s.accessToken);
  const [error, setError] = useState<string | null>(null);
  const [ok, setOk] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  if (!accessToken) return <Navigate to="/login?next=/submit-paper" replace />;

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    const form = new FormData(e.currentTarget);
    try {
      await submitPaper(form);
      setOk(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t.common.error);
    } finally {
      setSubmitting(false);
    }
  };

  if (ok) {
    return (
      <div className="dn-alert dn-alert-ok">
        <h2>{t.paper.success}</h2>
        <Link to="/dashboard">{t.register.goDashboard}</Link>
      </div>
    );
  }

  return (
    <div>
      <PageHeader title={t.paper.title} backTo="/dashboard" backLabel={t.nav.dashboard} />
      {error && <div className="dn-alert dn-alert-error">{error}</div>}
      <form className="dn-form" onSubmit={onSubmit}>
        <label>
          {t.paper.paperTitle}
          <input name="title" required />
        </label>
        <label>
          {t.paper.titleAlt}
          <input name="title_alt" />
        </label>
        <label>
          {t.paper.language}
          <select name="language" defaultValue={locale === "ar" ? "ar" : locale === "fr" ? "fr" : "en"}>
            <option value="en">{t.papers.langEnglish}</option>
            <option value="ar">{t.papers.langArabic}</option>
            <option value="fr">{t.papers.langFrench}</option>
          </select>
        </label>
        <label>
          {t.paper.abstract}
          <textarea name="abstract" required />
        </label>
        <label>
          {t.paper.keywords}
          <input name="keywords" />
        </label>
        <label>
          {t.paper.authors}
          <input name="authors" required />
        </label>
        <label>
          {t.paper.affiliation}
          <input name="affiliation" required />
        </label>
        <label>
          {t.paper.file}
          <input name="file" type="file" accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" required />
        </label>
        <label>
          {t.paper.notes}
          <textarea name="notes" />
        </label>
        <button className="dn-btn dn-btn-primary" disabled={submitting} type="submit">
          {t.paper.submit}
        </button>
      </form>
    </div>
  );
}
